<template>
  <div class="header">
    <img v-if="$route.path === '/dashboard'" alt="logo" src="./../assets/img/logo-dashboard.svg" class="logo desktop-hidden" @click="$router.push('/dashboard')">
    <span v-else class="desktop-hidden pointer" @click="backBtnClick">
      <svg width="22" height="22" viewBox="0 0 13 15" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M4.41421 8.5L8.70711 12.7929L7.29289 14.2071L0.585786 7.5L7.29289 0.792893L8.70711 2.20711L4.41421 6.5H13V8.5H4.41421Z" fill="#806DEF"/>
      </svg>
    </span>
    <img alt="logo" :src="$route.path === '/dashboard' ? imgUrl('logo-dashboard.svg') : imgUrl('logo-new.svg')" class="logo md-hidden" @click="$router.push('/dashboard')">
    <div v-if="user.email"
         v-click-outside="hideAccountDropdown"
         class="header-login flex-v-center account-settings-block">
      <span class="header-text pointer account-settings" @click="settingsDropdownOpen = !settingsDropdownOpen">
        <span class="account-settings-name">{{ user.displayName || user.email }}</span>
        <span class="account-settings-avatar" :class="{'-premium': isPremium}"></span>
      </span>
      <div class="account-settings-dropdown" v-if="settingsDropdownOpen">
        <router-link to="/account" class="account-settings-dropdown-item"><i class="icon-settings-bold"></i>Settings</router-link>
        <div class="account-settings-dropdown-item" @click="out()"><i class="icon-logout"></i>{{$lang.messages.sign_out}}</div>
      </div>
    </div>
  </div>
</template>

<script>

import {mapState} from "vuex";
import firebase from 'firebase/app'
import ClickOutside from 'vue-click-outside'
import {reportEvent} from "@/helpers/utils";
const images = require.context('../assets/img/', false, /\.svg$/)
export default {
  name: 'Header',
  props: ['siteSectionOpen', 'mobileOpen'],
  data: function() {
    return {
      settingsDropdownOpen: false,
      isAndroid: window.Android,
    }
  },
  computed: {
    ...mapState({
      user: state => state.user,
      currentDeviceID: state => state.currentDeviceID,
      isPremium: state => state.accountData.isPremium
    }),
  },
  methods: {
    imgUrl: function (path) {
      return images('./' + path)
    },
    backBtnClick(){
      if(this.$route.path === '/profile' && this.siteSectionOpen){
        this.$emit('openprofilesettings')
      } else {
        if(this.mobileOpen){
          this.$emit('closemobilemenu')
        } else {
          this.$router.back()
        }
      }
    },
    out() {
      firebase.auth().signOut();
      reportEvent('userSignOut');
    },
    goBackAndroid(){
      if (window.Android) {
        window.Android.sendJsMsgToBackApp();
      }
    },
    hideAccountDropdown(){
      this.settingsDropdownOpen = false
    }
  },
  directives: {
    ClickOutside
  }
}

</script>

<style lang="scss">
@import "../assets/styles/helpers";

.account-settings {
  font-size: 18px;
  display: flex;
  align-items: center;

  @include responsive-below($sm){
    font-size: 16px;
  }

  &-name {
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    font-size: 18px;
  }

  &-avatar {
    display: inline-block;
    min-width: 34px;
    width: 34px;
    height: 34px;
    padding: 4px;
    overflow: hidden;
    border-radius: 50%;
    background: #E3E5EF;
    vertical-align: middle;
    position: relative;

    &.-premium {
      background: #FDC031;
    }

    &:before {
      content: "";
      display: block;
      width: 28px;
      height: 28px;
      position: absolute;
      left: 3px;
      top: 3px;
      overflow: hidden;
      background: url("../assets/img/parent-profile.png") no-repeat center/contain;
    }
  }

  &-block {
    position: relative;

    .account-settings-avatar {
      margin-left: 8px;
    }
  }

  &-dropdown {
    background: #FFFFFF;
    border-radius: 20px;
    padding: 12px 24px;
    position: absolute;
    z-index: 10;
    top: 100%;
    right: 0;
    min-width: 220px;

    &-item {
      font-weight: 700;
      margin: 12px 0;
      cursor: pointer;
      color: #27272C;
      display: block;

      &-muted {
        opacity: 0.7;
        cursor: default;
      }
      
      &:hover {
        text-decoration: none;
        color: #7D6AED;
      }

      i {
        margin-right: 10px;
        vertical-align: middle;
        color: #5A4A99;
      }
    }
  }
}

</style>
